import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import axios from "axios";
var AddSponsorView = /** @class */ (function (_super) {
    tslib_1.__extends(AddSponsorView, _super);
    function AddSponsorView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sponsorAdded = false;
        _this.banks = null;
        _this.sponsor = {
            sponsorId: null,
            firstname: null,
            lastname: null,
            fullName: null,
            email: null,
            sponsorType: "Private",
            companyName: null,
            payment: null,
            paymentMethod: "Manual",
            billSentOn: null,
            participationStatus: "Participates",
            notificationSentOn: null,
            numNotificationsSent: 0,
            shouldPay: null,
            paid: 0,
            estimatedPayment: null,
            eventParticipantId: store.selectedEvent.eventParticipant.eventParticipantId,
            streetAddress: "",
            zipCode: "",
            city: "",
            sendingEmail: false,
            editingEmail: false,
            info: null,
            preferredBillingMethod: "Email",
            eInvoicePaymentAddress: "",
        };
        _this.store = store;
        return _this;
    }
    AddSponsorView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, axios.get("banks")];
                    case 1:
                        _a.banks = (_b.sent()).data;
                        this.sponsorAdded = false;
                        store.page.title = this.$t("addSponsorView.title");
                        store.page.showTopNav = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddSponsorView.prototype.billingMethodChanged = function () {
    };
    Object.defineProperty(AddSponsorView.prototype, "minPayment", {
        get: function () {
            if (this.sponsor.paymentMethod == "Manual")
                return store.globalSettings.paymentMinManual;
            else
                return store.globalSettings.paymentMinPerRepeat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddSponsorView.prototype, "isValidatedForSave", {
        get: function () {
            var _this = this;
            if (!this.sponsor.payment || this.sponsor.payment < this.minPayment)
                return false;
            // if (this.isDuplicateSponsor)
            //    return false;
            var requiredFields = [];
            if (this.sponsor.sponsorType === "Private") {
                requiredFields = [
                    this.sponsor.firstname,
                    this.sponsor.lastname,
                ];
            }
            if (this.sponsor.sponsorType === "Company")
                requiredFields = [this.sponsor.companyName];
            switch (this.sponsor.preferredBillingMethod) {
                case "Mail":
                    requiredFields.push(this.sponsor.streetAddress, this.sponsor.city, this.sponsor.zipCode);
                    break;
                case "Email":
                    requiredFields.push(this.sponsor.email);
                    break;
                case "EInvoice":
                    var selectedBank = this.banks.find(function (b) { return b.bankId == _this.sponsor.bankId; });
                    var bankName = null;
                    if (selectedBank)
                        bankName = selectedBank.name;
                    requiredFields.push(bankName, this.sponsor.eInvoicePaymentAddress);
                    break;
            }
            return this.validateTextInputs(requiredFields);
        },
        enumerable: true,
        configurable: true
    });
    AddSponsorView.prototype.validateTextInputs = function (fields) {
        var isValidTextInput = function (s) { return s && s.trim().length > 0; };
        return fields
            .map(isValidTextInput)
            .every(function (x) { return x === true; });
    };
    AddSponsorView.prototype.addSponsor = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sponsorId, newSponsor, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, axios.post("sponsors", this.sponsor, { params: { eventId: store.selectedEvent.eventId } })];
                    case 1:
                        sponsorId = (_a.sent()).data.sponsorId;
                        return [4 /*yield*/, axios.get("sponsors/" + sponsorId)];
                    case 2:
                        newSponsor = (_a.sent()).data;
                        store.selectedEvent.sponsors.push(newSponsor);
                        this.sponsorAdded = true;
                        this.$router.push("/sponsors?sponsorAdded");
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddSponsorView.prototype.perRepeatPaymentSelected = function (e) {
        var value = e.target.value;
        if (value === "PerRepeat" && this.sponsor.payment)
            this.sponsor.payment = 0;
    };
    Object.defineProperty(AddSponsorView.prototype, "isDuplicateSponsor", {
        get: function () {
            var _this = this;
            if (this.sponsor.email === null)
                return false;
            return store.selectedEvent.sponsors.find(function (s) { return s.email === _this.sponsor.email && s.sponsorType === _this.sponsor.sponsorType; }) != null;
        },
        enumerable: true,
        configurable: true
    });
    AddSponsorView.prototype.zipCodeChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, http, locations, cityName, language, locations_1, locations_1_1, l, postalCodeName, municipality;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        http = axios.create({
                            baseURL: "https://locationservice.posti.com",
                        });
                        return [4 /*yield*/, http.get("location?zipCode=" + this.sponsor.zipCode + "&types=POBOX&types=PICKUPPOINT&types=POSTOFFICE")];
                    case 1:
                        locations = (_b.sent()).data.locations;
                        locations.sort(function (a, b) {
                            if (a.type == "POSTOFFICE")
                                return -1;
                            else if (a.type == "PICKUPPOINT")
                                return -1;
                            return 1;
                        });
                        cityName = "";
                        language = this.$i18n.locale == "se" ? "sv" : this.$i18n.locale;
                        try {
                            for (locations_1 = tslib_1.__values(locations), locations_1_1 = locations_1.next(); !locations_1_1.done; locations_1_1 = locations_1.next()) {
                                l = locations_1_1.value;
                                postalCodeName = l.address[language].postalCodeName;
                                municipality = l.address[language].municipality;
                                if (postalCodeName) {
                                    cityName = postalCodeName;
                                    break;
                                }
                                else if (municipality)
                                    cityName = municipality;
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (locations_1_1 && !locations_1_1.done && (_a = locations_1.return)) _a.call(locations_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        this.sponsor.city = cityName;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddSponsorView = tslib_1.__decorate([
        Component
    ], AddSponsorView);
    return AddSponsorView;
}(Vue));
export default AddSponsorView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/AddSponsorView.vue
// module id = 55
// module chunks = 0